export default __webpack_public_path__ + "static/media/favicon.45c5c70c.ico";